<template>
  <el-container type="flex" class="main_container">
    <base-header><i class="el-icon-arrow-left back" @click="goBack"></i>编辑商品</base-header>
    <personal-form></personal-form>
  </el-container>
</template>

<script>
import PersonalForm from '../common/PersonalForm'

export default {
  name: 'GoodsEdit',
  components: { PersonalForm },
  methods: {
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  .back {
    cursor: pointer;
  }
  .back:hover {
    color: #3a8ee6;
  }
</style>
